/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */

export const UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS = {
	hasSeenUniversalCreateCwRExperimentSpotlight:
		'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight',
} as const;

export const UniversalCreateCwRExperimentSpotlightOnboardingKeys = [
	...Object.values(UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS),
] as const;
